<template>
  <div>
    <!-- 查询表单 -->
    <el-form
    :inline="true"
    ref="search_form"
    :model="search_form"
    label-width="80px"
    class="search_form"
    >
      <el-form-item label="科目" prop="itemName">
        <el-input v-model="search_form.itemName"></el-input>
      </el-form-item>
      <el-form-item label="供应商" prop="supplier">
        <el-input v-model="search_form.supplier"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
        type="primary"
        icon="el-icon-plus"
        @click="add_message"
        v-if="btn_permission.includes('middle:consumableMaterial:addBase')||btn_permission.includes('superAdmin')"
        >录入</el-button>
        <el-button
        type="primary"
        icon="el-icon-search"
        @click="search_message"
        v-if="btn_permission.includes('middle:consumableMaterial:baseList')||btn_permission.includes('superAdmin')"
        >查询</el-button>
        <el-button
        icon="el-icon-close"
        @click="reset_message"
        v-if="btn_permission.includes('middle:consumableMaterial:baseList')||btn_permission.includes('superAdmin')"
        >清除</el-button>
      </el-form-item>
    </el-form>
    <!-- 新增基础耗材弹框 -->
    <el-dialog
    :append-to-body="true"
    :visible.sync="addVisible"
    :title="add_edit_title"
    >
      <el-form
      ref="add_form"
      :model="add_form"
      label-width="100px"
      class="add_form"
      :rules="add_rules"
      :disabled="add_form_status"
      >
        <el-form-item label="科目" prop="itemName">
          <el-input placeholder="请输入科目" v-model="add_form.itemName"></el-input>
        </el-form-item>
        <el-form-item label="明细" prop="itemDetail">
          <el-input placeholder="请输入明细" v-model="add_form.itemDetail"></el-input>
        </el-form-item>
        <el-form-item label="规格" prop="standard">
          <el-input placeholder="请输入规格" v-model="add_form.standard"></el-input>
        </el-form-item>
        <el-form-item label="供应商" prop="supplier">
          <el-input placeholder="请输入供应商" v-model="add_form.supplier"></el-input>
        </el-form-item>
        <el-form-item label="单价" prop="price">
          <el-input placeholder="请输入单价" v-model="add_form.price"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
          type="primary"
          icon="el-icon-circle-check"
          @click="save_message"
          >保存</el-button>
          <el-button
          icon="el-icon-circle-close"
          @click="cancel_message"
          >关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 基础信息列表 -->
    <el-table
    :data="list_data"
    highlight-current-row
    border
    max-height="400"
    >
      <el-table-column
      align="center"
      prop="itemName"
      label="科目"
      ></el-table-column>
      <el-table-column
      show-overflow-tooltip
      align="center"
      prop="itemDetail"
      label="明细"
      ></el-table-column>
      <el-table-column
      show-overflow-tooltip
      align="center"
      prop="standard"
      label="规格"
      ></el-table-column>
      <el-table-column
      align="center"
      prop="price"
      label="单价"
      ></el-table-column>
      <el-table-column
      align="center"
      prop="supplier"
      label="供应商"
      ></el-table-column>
      <el-table-column
      align="center"
      prop="createName"
      label="创建人"
      ></el-table-column>
      <el-table-column
      align="center"
      prop="createDate"
      label="创建日期"
      width="160px"
      ></el-table-column>
      <el-table-column
      align="center"
      prop="updateName"
      label="修改人"
      ></el-table-column>
      <el-table-column
      show-overflow-tooltip
      align="center"
      prop="updateDate"
      label="修改日期"
      ></el-table-column>
      <el-table-column width="200px" align="center" fixed="right" label="操作">
        <template slot-scope="scope">
          <el-tag
          class="operate"
          type="success"
          effect="dark"
          @click="check_detail(scope.row)"
          v-if="btn_permission.includes('middle:consumableMaterial:baseById')||btn_permission.includes('superAdmin')"
          >查看明细</el-tag>
          <el-tag
          class="operate"
          effect="dark"
          type="warning"
          @click="edit_message(scope.row)"
          v-if="btn_permission.includes('middle:consumableMaterial:editBase')||btn_permission.includes('superAdmin')"
          >修改</el-tag>
          <el-tag
          class="operate"
          effect="dark"
          type="danger"
          @click="delete_message(scope.row)"
          v-if="btn_permission.includes('middle:consumableMaterial:delBase')||btn_permission.includes('superAdmin')"
          >删除</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <!-- 基础信息列表分页 -->
    <el-pagination
    style="margin: 10px auto;"
    background
    @size-change="message_size_change"
    @current-change="message_current_change"
    :current-page="message_current_page"
    :page-sizes="[10,15,20,25]"
    :page-size="message_page_size"
    layout="total, sizes, prev, pager, next, jumper"
    :total="message_total"
    ></el-pagination>
  </div>
</template>

<script>
  export default {
    data() {
      return{
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        // 查询表单
        search_form:{
          itemName:'',
          supplier:''
        },
        add_edit_title:'',
        add_edit:'',
        now_row:{},
        //新增基础耗材弹框
        addVisible:false,
        add_rules:{
          itemName:[
            {required:true,message:'请输入科目',trigger:'blur'}
          ],
          itemDetail:[
            {required:true,message:'请输入明细',trigger:'blur'}
          ],
          standard:[
            {required:true,message:'请输入规格',trigger:'blur'}
          ],
          supplier:[
            {required:true,message:'请输入供应商',trigger:'blur'}
          ],
          price:[
            {required:true,message:'请输入单价',trigger:'blur'}
          ]
        },
        add_form:{
          itemName:'',
          itemDetail:'',
          standard:'',
          supplier:'',
          price:''
        },
        //基础耗材表单禁用状态
        add_form_status:false,
        //基础信息列表
        list_data:[],
        //基础信息列表分页
        message_current_page:1,
        message_page_size:10,
        message_total:0
      }
    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      //获取基础信息列表
      that.get_message()
    },
    mounted() {

    },
    methods:{
      //获取基础信息列表
      get_message(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/consumableMaterial/base/list',
          params:{
            page:that.message_current_page,
            limit:that.message_page_size,
            itemName:that.search_form.itemName,
            supplier:that.search_form.supplier
          }
        }).then(data=>{
          if(data.data.success==true){
            that.list_data=data.data.data.list
            that.message_total=data.data.data.total
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //查询表单
      search_message(){
        this.message_current_page=1
        this.message_page_size=10
        //获取基础信息列表
        this.get_message()
      },
      //重置查询表单
      reset_message(){
        this.$refs.search_form.resetFields()
        this.message_current_page=1
        this.message_page_size=10
        //获取基础信息列表
        this.get_message()
      },
      //基础信息列表分页
      message_size_change(val){
        this.message_page_size=val
        //获取基础信息列表
        this.get_message()
      },
      message_current_change(val){
        this.message_current_page=val
        //获取基础信息列表
        this.get_message()
      },
      //新增基础耗材前置
      add_message(){
        this.addVisible=true
        this.add_form_status=false
        this.add_edit='add'
        this.add_edit_title='新增基础弹框'
        if(this.$refs.add_form!=undefined){
          this.$refs.add_form.resetFields()
        }
      },
      //修改基础耗材前置
      edit_message(row){
        this.addVisible=true
        this.add_form_status=false
        this.add_edit='edit'
        this.add_edit_title='修改基础弹框'
        this.now_row=row
        this.add_form.itemName=row.itemName
        this.add_form.itemDetail=row.itemDetail
        this.add_form.standard=row.standard
        this.add_form.supplier=row.supplier
        this.add_form.price=row.price
      },
      //新增或修改基础耗材保存
      save_message(){
        let that=this
        that.$refs.add_form.validate((valid)=>{
          if(valid){
            if(that.add_edit=='add'){
              that.$axios({
                method:'post',
                url:that.publicAjax.extra_path+'/middle/consumableMaterial/base',
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:that.add_form
              }).then(data=>{
                if(data.data.success==true){
                  that.addVisible=false
                  //获取基础信息列表
                  that.get_message()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.warning(data.data.message)
                }
              })
            }else if(that.add_edit=='edit'){
              that.$axios({
                method:'put',
                url:that.publicAjax.extra_path+'/middle/consumableMaterial/base/'+that.now_row.id,
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:that.add_form
              }).then(data=>{
                if(data.data.success==true){
                  that.addVisible=false
                  //获取基础信息列表
                  that.get_message()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.warning(data.data.message)
                }
              })
            }
          }else{
            return false
          }
        })
      },
      //取消新增或修改
      cancel_message(){
        this.addVisible=false
      },
      //删除基础耗材
      delete_message(row){
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'delete',
            url:that.publicAjax.extra_path+'/middle/consumableMaterial/base/'+row.id
          }).then(data=>{
            if(data.data.success==true){
              //获取基础信息列表
              that.get_message()
              that.$message.success(data.data.message)
            }else{
              that.$message.warning(data.data.message)
            }
          })
        }).catch(()=>{

        })
      },
      //查看明细
      check_detail(row){
        this.addVisible=true
        this.add_form_status=true
        this.add_edit_title='查看基础耗材详情'
        this.add_form.itemName=row.itemName
        this.add_form.itemDetail=row.itemDetail
        this.add_form.standard=row.standard
        this.add_form.supplier=row.supplier
        this.add_form.price=row.price
      }
    }
  }
</script>

<style scoped="scoped">
  .operate{
    margin-bottom: 2px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/expense/message.vue